import React from 'react';
import { useHistory } from 'react-router-dom';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import pencilIconTokens from '@amzn/meridian-tokens/base/icon/pencil';
import Tooltip from '@amzn/meridian/tooltip';
import { HostEditUri } from '$/features/routes';
import { HostData } from '@amzn/dots-host-agent-management-service-client';

export type HostEditButtonProps = {
  host: HostData;
};

export function HostEditButton({ host }: HostEditButtonProps): JSX.Element {
  const history = useHistory();
  return (
    <Tooltip title={`Edit ${host.accountName}`} position="bottom">
      <Button
        type="tertiary"
        onClick={() => history.push(HostEditUri(host.accountName!))}
      >
        <Icon tokens={pencilIconTokens} />
      </Button>
    </Tooltip>
  );
}
